import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { NavLink, useParams } from 'react-router-dom';

import routes from '@routes';
import Loader from '@components/Loader';
import {
  Avatar,
  BelowLogo,
  Logo,
  Logout,
  Wrapper,
  UserLine,
  Navigation,
  NavigationItem,
  NavigationItemLink,
} from '@components/Sidebar/style';
import LabelsList from '@components/Sidebar/LabelsList';

const Sidebar = ({
  authStore: { customer, logout, fetchCustomer, loadingCustomer },
  musicStore: { fetchLabels, selectLabel },
}) => {
  useEffect(() => {
    const getUser = async () => {
      await fetchCustomer();
    };

    getUser();
  }, []);

  const { uuid, kind } = useParams();

  useEffect(() => {
    fetchLabels(uuid);
  }, []);

  useEffect(() => {
    if (uuid) {
      selectLabel(uuid, kind);
    }
  }, [uuid, kind]);

  return (
    <Wrapper>
      <NavLink to={routes.labels}>
        <Logo src="/images/intervox-logo.png" alt="intervox" />
      </NavLink>
      <BelowLogo>
        {loadingCustomer ? (
          <Loader />
        ) : (
          <UserLine>
            <Avatar>
              {customer.first_name ? customer.first_name.charAt(0) : null}
              {customer.last_name ? customer.last_name.charAt(0) : null}
            </Avatar>
            <Logout onClick={logout} type="button">
              <img src="/images/icons/logout.svg" alt="logout" />
            </Logout>
          </UserLine>
        )}
        <Navigation>
          <ul>
            <NavigationItem>
              <NavigationItemLink icon="album" activeClassName="active">
                Albums delivery
              </NavigationItemLink>

              <LabelsList />
              <br />
              <NavigationItemLink icon="album" activeClassName="active">
                Stems delivery
              </NavigationItemLink>

              <LabelsList ofStems />
            </NavigationItem>
          </ul>
        </Navigation>
      </BelowLogo>
    </Wrapper>
  );
};

export default inject('authStore', 'musicStore')(observer(Sidebar));
